/**
 * Posición del panel de una burbuja flotante arrastrable.
 *
 * Las burbujas se anclan con useDraggable, que las deja en cualquiera de seis zonas del
 * viewport. El panel no puede tener una posición fija en CSS: si la burbuja está arriba
 * el panel tiene que abrir hacia ABAJO, si está abajo hacia ARRIBA, y en los bordes
 * laterales tiene que recortarse contra la pantalla en vez de salirse. Esa cuenta vivía
 * escrita a mano adentro de WhatsAppBubble; al hacer arrastrable la de tickets iba a
 * quedar duplicada, que es exactamente cómo la burbuja de tickets terminó sin el
 * tratamiento de área segura que la de WhatsApp sí tenía.
 *
 * En móvil devuelve {} a propósito: ahí el panel ocupa el ancho completo y lo resuelve
 * el CSS, que además tiene que descontar la barra de navegación inferior y el área
 * segura del teléfono — cosas que sólo el CSS conoce.
 *
 * @param {{x:number,y:number}} pos       posición actual de la burbuja (de useDraggable)
 * @param {object} opts
 * @param {number} opts.width            ancho del panel en px
 * @param {number} opts.height           alto deseado del panel en px
 * @param {number} [opts.fabSize=52]     lado de la burbuja
 * @param {number} [opts.gap=8]          separación entre burbuja y panel
 * @param {number} [opts.minHeight=250]  alto mínimo antes de preferir el otro lado
 */
import { getDockInsets } from '../hooks/useDraggable';

export function bubblePanelStyle(pos, opts) {
  const { width, height, fabSize = 52, gap = 8, minHeight = 250 } = opts;
  if (typeof window === 'undefined') return {};
  if (window.innerWidth < 768) return {};

  // El panel tampoco tapa la barra lateral ni el encabezado (mismas medidas que el dock).
  const safe = getDockInsets();
  const minLeft = safe.left + gap;
  const maxLeft = window.innerWidth - safe.right - width - gap;
  let left = pos.x + fabSize / 2 - width / 2;
  left = Math.max(minLeft, Math.min(maxLeft, left));
  left = Math.max(gap, left); // ventana más angosta que panel + barra: al menos que entre

  const spaceAbove = pos.y - safe.top - gap;
  const spaceBelow = window.innerHeight - safe.bottom - (pos.y + fabSize + gap);

  // Abre hacia arriba si entra, o si de los dos lados es el que más lugar tiene.
  const openAbove = spaceAbove >= Math.min(height, minHeight) || spaceAbove > spaceBelow;
  if (openAbove) {
    return {
      position: 'fixed',
      bottom: window.innerHeight - pos.y + gap,
      left, right: 'auto', top: 'auto',
      maxHeight: Math.max(minHeight, spaceAbove - gap),
    };
  }
  return {
    position: 'fixed',
    top: pos.y + fabSize + gap,
    left, right: 'auto', bottom: 'auto',
    maxHeight: Math.max(minHeight, spaceBelow - gap),
  };
}

export default bubblePanelStyle;
